import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { PAGE, LIMIT } from "src/constants/searchParams";
import { useFilters } from "./useFilters";
import { useBatchFilters } from "./useBatchFilters";
import { Pagination } from "src/api/types";

export function usePagination(): Pagination {
  const batchUpdate = useBatchFilters();
  const [limit] = useFilters(LIMIT, ROWS_PER_PAGE[0].toString());
  const [page, setPage] = useFilters(PAGE, "0");
  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage.toString());
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    batchUpdate((p) => {
      p.set(LIMIT, event.target.value);
      p.set(PAGE, "0");
      return p;
    });
  };

  return {
    limit: Number(limit),
    page: Number(page),
    handleChangePage,
    handleChangeRowsPerPage,
  };
}
